import { render, staticRenderFns } from "./BudgetApplyNew.vue?vue&type=template&id=38094216&scoped=true&"
import script from "./BudgetApplyNew.vue?vue&type=script&lang=js&"
export * from "./BudgetApplyNew.vue?vue&type=script&lang=js&"
import style0 from "./BudgetApplyNew.vue?vue&type=style&index=0&id=38094216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38094216",
  null
  
)

export default component.exports